import type { TUpdatePricingCategory } from './types';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const updatePricingCategory = async ({
  priceSchemeId,
  categoryId,
  newName,
  displayOrder,
  newParentId,
}: TUpdatePricingCategory): Promise<void> => {
  const url = `${API_URL}/pricing/schemes/${priceSchemeId}/categories/${categoryId}`;

  const res = await fetch(url, {
    method: 'PATCH',
    body: JSON.stringify({
      name: newName,
      display_order: displayOrder,
      parent_category_id: newParentId,
    }),
    cache: 'reload',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  if (!res.ok) {
    throw new Error('Unable to update pricing category');
  }
};
